<template>
    <div>
      <div class="row mt-4">
        <div class="col-md-8">
          <h4>
            <b-badge pill variant="success" v-if="firebaseDriver.authenticated" class="mr-2">Autenticado</b-badge>
            <b-badge pill variant="default" v-else class="mr-2">Autenticado</b-badge>
            <b-badge pill variant="success" v-if="firebaseDriver.active" class="mr-2">Disponible</b-badge>
            <b-badge pill variant="default" v-else class="mr-2">Disponible</b-badge>
            <b-badge pill variant="success" v-if="firebaseDriver.onTrip" class="mr-2">En viaje</b-badge>
            <b-badge pill variant="default" v-else class="mr-2">En viaje</b-badge>
          </h4>
        </div>
        <div class="col-md-4 text-center">
          <h1 class="mb-0">$ {{ monedero(firebaseDriver.balance) }}</h1>
          <h5 class="text-muted">Monedero</h5>
        </div>
      </div>
      <hr>
      <div class="row" v-if="this.firebaseDriver&&this.firebaseDriver.vehicle">
        <div class="col-md-3">
          <div class="form-group">
            <label class="form-label-control mb-0 text-muted">Marca</label>
            <p v-if="this.firebaseDriver.vehicle">{{ this.firebaseDriver.vehicle.brand }}</p>
          </div>
          <div class="form-group">
            <label class="form-label-control mb-0 text-muted">Sub-marca</label>
            <p>{{ this.firebaseDriver.vehicle.subBrand }}</p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label class="form-label-control mb-0 text-muted">Modelo</label>
            <p>{{ this.firebaseDriver.vehicle.model }}</p>
          </div>
          <div class="form-group">
            <label class="form-label-control mb-0 text-muted">Año</label>
            <p>{{ this.firebaseDriver.vehicle.year }}</p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label class="form-label-control mb-0 text-muted">Placa</label>
            <p>{{ this.firebaseDriver.vehicle.licensePlate }}</p>
          </div>
          <div class="form-group">
            <label class="form-label-control mb-0 text-muted">Número de serie</label>
            <p>{{ this.firebaseDriver.vehicle.serialNumber }}</p>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label class="form-label-control mb-0 text-muted">Modelo</label>
            <p>{{ this.firebaseDriver.vehicle.model }}</p>
          </div>
          <div class="form-group">
            <label class="form-label-control mb-0 text-muted">Tipo de vehículo</label>
            <p>{{ this.firebaseDriver.vehicle.vehicleType.type }}</p>
          </div>
        </div>
      </div>
      <!-- b-row>
        <b-col md="6" class="my-1">
          <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" class="form-control" placeholder="Buscar conductor"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="6" class="my-1">
          <b-form-group label-cols-sm="3" label="Registros por página" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions" class="form-control"></b-form-select>
          </b-form-group>
        </b-col>
        <b-table
            show-empty
            stacked="md"
            :items="getActiveTaxiCheckIn"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
            empty-text="No existen registros por mostrar"
            emptyFilteredText="No existen registros por mostrar"
          >
            <template v-slot:cell(actions)='row'>
              <b-button variant="success" size="md" @click="searchVehicle(row.item.driver.id)" class="mr-2">
                Ver en mapa
              </b-button>
            </template>
          </b-table>
          <b-row>
            <b-col md="6" class="my-1">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
      </-->
    </div>
  </template>
<script>
import firebase from 'firebase'
export default {
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
    firebaseDriver: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      icon:
        [
          'T1V.svg',
          'T1A.png',
          'T1R.png',
        ],
      fields: [
        { key: 'driver.id', label: 'Id' },
        { key: 'driver.firstName', label: 'Nombre(s)' },
        { key: 'driver.lastName', label: 'Apellidos' },
        { key: 'driver.license', label: 'Número de licencia' },
        { key: 'driver.cardId', label: 'Número de tarjetón' },
        { key: 'driver.email', label: 'Correo electrónico' },
        { key: 'driver.phoneNumber', label: 'Número de teléfono' },
        { key: 'concesion.vehicle.vehicleType.type', label: 'Tipo de vehículo' },
        { key: 'concesion.vehicle.licensePlate', label: 'Número de placa' },
        { key: 'concesion.vehicle.brand', label: 'Marca' },
        { key: 'concesion.vehicle.model', label: 'Modelo' },
        { key: 'actions', label: 'Acciones (Ver en mapa)' },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      googleMapMarker: [],
      infoWindows: [],
      status: [],
      driverId: null,
      currentDriver: this.$root._route.params,
      // firebaseDriver: {},
      getActiveTaxiCheckIn: [],
      colors: {
        inactive: '#5D716E',
        available: '#29D336',
        unavailable: '#FF0000',
      },
      unsubscribe: null,
      driverFirebase: {},
      failCopy: 'No se encontró al conductor en el mapa. Intenta más tarde, si el problema persiste ponte en contacto con el administrador.',
    }
  },
  async mounted() {
    // await this.getDrivers()
    const { Marker, LatLng, InfoWindow } = this.google.maps
    if (this.firebaseDriver.location) {
      const position = new LatLng(this.firebaseDriver.location.position.geopoint.latitude, this.firebaseDriver.location.position.geopoint.longitude)
      const color = this.firebaseDriver.active ? (this.firebaseDriver.driver.onTrip ? this.colors.unavailable : this.colors.available) : this.colors.inactive
      const symbol = {
        path: 'M62.1,36.5c-0.9-1.2-3.6-1.5-3.6-1.5c0.1-3.5,0.5-6.9,0.7-8.2c1.9-7.3-1.7-11.8-1.7-11.8c-4.8-4.8-9.1-5-12.5-5   c-3.4,0-7.8,0.3-12.5,5c0,0-3.6,4.5-1.7,11.8c0.2,1.2,0.5,4.6,0.7,8.2c0,0-2.7,0.3-3.6,1.5c-0.9,1.2-0.9,1.9,0,1.9   c0.9,0,2.9-2.3,3.6-2.3V35c0,1,0.1,2,0.1,3c0,4.4,0,33.7,0,33.7s-0.3,6.1,5,7.8c1.2,0,4.6,0.4,8.4,0.5c3.8-0.1,7.3-0.5,8.4-0.5   c5.3-1.7,5-7.8,5-7.8s0-29.3,0-33.7c0-1,0-2,0.1-3v1.2c0.7,0,2.7,2.3,3.6,2.3C63,38.5,63,37.7,62.1,36.5z M34.7,66.5   c-0.3,3.3-2.3,4.1-2.3,4.1V37.4c0.8,1.2,2.3,6.8,2.3,6.8S34.9,63.2,34.7,66.5z M54.8,75.2c0,0-4.2,2.3-9.8,2.2   c-5.6,0.1-9.8-2.2-9.8-2.2v-2.8c4.9,2.2,9.8,2.2,9.8,2.2s4.9,0,9.8-2.2V75.2z M35.2,41.1l-1.7-10.2c0,0,4.5-3.2,11.5-3.2   s11.5,3.2,11.5,3.2l-1.7,10.2C51.4,39.2,38.6,39.2,35.2,41.1z M57.7,70.6c0,0-2.1-0.8-2.3-4.1c-0.3-3.3,0-22.4,0-22.4   s1.5-5.6,2.3-6.8V70.6z',
        fillColor: color,
        fillOpacity: 0.8,
        strokeColor: color,
        anchor: new this.google.maps.Point(45, 45),
        scale: 0.5,
        rotation: this.firebaseDriver.location.heading,
      }
      const marker = new Marker({
        position: position,
        marker: this.firebaseDriver,
        map: this.map,
        icon: symbol,
        id: this.firebaseDriver.id,
      })
      const infoWindow = new InfoWindow({
        disableAutoPan: true,
      })
      this.infoWindows[this.firebaseDriver.id] = infoWindow
      marker.addListener('click', () => {
        const content = `
                <div class="ui header">Marca de vehículo: ${this.firebaseDriver.vehicle.brand}</div>
                <div class="ui header">Modelo de vehículo: ${this.firebaseDriver.vehicle.model}</div>
                <div class="ui header">Placa del vehículo: ${this.firebaseDriver.vehicle.licensePlate}</div>
                <div class="ui header">Tipo de vehículo: ${this.firebaseDriver.vehicle.vehicleType.type}</div>
                <div class="ui header">Nombre de conductor: ${this.firebaseDriver.driver.firstName}</div>
                <div class="ui header">Apellido de conductor: ${this.firebaseDriver.driver.lastName}</div>
              `
        this.infoWindows[this.firebaseDriver.id].setContent(content)
        this.infoWindows[this.firebaseDriver.id].open(this.map, marker)
      })
      this.googleMapMarker[this.firebaseDriver.id] = marker
      this.searchVehicle(this.firebaseDriver.id)
    }

    this.unsubscribe = firebase
      .firestore()
      .collection('drivers')
      .onSnapshot(snapshot => {
        if (snapshot.docChanges()[0].type === 'modified') {
          snapshot.docChanges().forEach(document => {
            const driver = document.doc.data()
            const id = document.doc.id
            const location = document.doc.location
            const position = new LatLng(location.position.geopoint.latitude, location.position.geopoint.longitude)
            const color = driver.active ? (driver.onTrip ? this.colors.unavailable : this.colors.available) : this.colors.inactive
            const symbol = {
              path: 'M62.1,36.5c-0.9-1.2-3.6-1.5-3.6-1.5c0.1-3.5,0.5-6.9,0.7-8.2c1.9-7.3-1.7-11.8-1.7-11.8c-4.8-4.8-9.1-5-12.5-5   c-3.4,0-7.8,0.3-12.5,5c0,0-3.6,4.5-1.7,11.8c0.2,1.2,0.5,4.6,0.7,8.2c0,0-2.7,0.3-3.6,1.5c-0.9,1.2-0.9,1.9,0,1.9   c0.9,0,2.9-2.3,3.6-2.3V35c0,1,0.1,2,0.1,3c0,4.4,0,33.7,0,33.7s-0.3,6.1,5,7.8c1.2,0,4.6,0.4,8.4,0.5c3.8-0.1,7.3-0.5,8.4-0.5   c5.3-1.7,5-7.8,5-7.8s0-29.3,0-33.7c0-1,0-2,0.1-3v1.2c0.7,0,2.7,2.3,3.6,2.3C63,38.5,63,37.7,62.1,36.5z M34.7,66.5   c-0.3,3.3-2.3,4.1-2.3,4.1V37.4c0.8,1.2,2.3,6.8,2.3,6.8S34.9,63.2,34.7,66.5z M54.8,75.2c0,0-4.2,2.3-9.8,2.2   c-5.6,0.1-9.8-2.2-9.8-2.2v-2.8c4.9,2.2,9.8,2.2,9.8,2.2s4.9,0,9.8-2.2V75.2z M35.2,41.1l-1.7-10.2c0,0,4.5-3.2,11.5-3.2   s11.5,3.2,11.5,3.2l-1.7,10.2C51.4,39.2,38.6,39.2,35.2,41.1z M57.7,70.6c0,0-2.1-0.8-2.3-4.1c-0.3-3.3,0-22.4,0-22.4   s1.5-5.6,2.3-6.8V70.6z',
              fillColor: color,
              fillOpacity: 0.8,
              strokeColor: color,
              anchor: new this.google.maps.Point(45, 45),
              scale: 0.5,
              rotation: driver.location.heading,
            }
            this.googleMapMarker[id].setPosition(position)
            this.googleMapMarker[id].setIcon(symbol)
          })
        }
      })
  },
  // eslint-disable-next-line vue/require-render-return
  render() {},
  methods: {
    /*  async getDrivers() {
      try {
        const driver = await firebase.firestore().collection('drivers').where('driver.id', '==', this.currentDriver.id).get()
        if (driver.docs.length === 0) {
          this.makeToast(true, 'danger', 'Error', this.failCopy)
          return
        }
        this.firebaseDriver = driver.docs[0].data()
        console.log(this.firebaseDriver)
      } catch (error) {
        this.makeToast(true, 'danger', 'Error', this.failCopy)
        console.log(error)
      }
    },  */
    searchVehicle(driverId) {
      if (this.googleMapMarker[driverId]) {
        const marker = this.googleMapMarker[driverId]
        this.map.panTo(marker.getPosition())
      // }
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    makeToast(append = false, variant, title, message) {
      this.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 2000,
        appendToast: append,
        variant: variant,
      })
    },
    monedero: function (amount) {
      if (!amount) { return '$0.00' }
      return parseFloat(amount).toFixed(2)
    },
  },
  beforeDestroy() {
    this.unsubscribe()
    console.log('Component Destroyed')
  },
  apollo: {
  },
}
</script>
